import { useAutoApplyResumeDistributionModal } from './useAutoApplyResumeDistributionModal'
import { NonSupportedUserAutoApplyResumeDistributionModal } from './NonSupportedUserAutoApplyResumeDistributionModal'
import { SupportedUserAutoApplyResumeDistributionModal } from './SupportedUserAutoApplyResumeDistributionModal'

export const AutoApplyResumeDistributionModal = () => {
  const { isOpen, closeModal, planName, label, modalType } = useAutoApplyResumeDistributionModal()

  if (!isOpen) return null

  if (modalType === 'supported_user_aa_rd_modal') {
    return <SupportedUserAutoApplyResumeDistributionModal closeModal={closeModal} />
  }

  if (modalType === 'non_supported_user_aa_rd_modal') {
    return (
      <NonSupportedUserAutoApplyResumeDistributionModal
        planName={planName}
        closeModal={closeModal}
        label={label}
      />
    )
  }
  return null
}
